import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${(props) => props.theme.newPalette.neutral.N300};
  padding: 0px 30px 0px 32px;
`;

export const Title = styled.h2`
  display: block;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
`;

export const Subtitle = styled.h3`
  display: block;
  font-family: ${(props) => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: 500;
  margin-top: 0px;
  margin-bottom: 24px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 24px;
`;

export const BottomRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 8px;
`;
